import { sponsoredAdKeywordsGetAll } from '../../services/servicesSponsoredAds';

const modalConfig = {
   title: 'Keywords',
   resource: 'keyword',
   fetchResource: sponsoredAdKeywordsGetAll,
   resourceMiddleWare: (data) => {
      const keywordsByCategory = {
         categories: ['jobTitle', 'company', 'industry'],
         categoryTitles: ['Job Title', 'Company', 'Industry'],
         length: data?.jobTitle?.length + data?.company?.length + data?.industry?.length,
      };
      keywordsByCategory.jobTitle = data?.jobTitle?.map((keyword) => ({
         id: `${ keyword.id }`, value: keyword.name, label: keyword.name,
      }));
      keywordsByCategory.company = data?.company?.map((keyword) => ({
         id: `${ keyword.id }`, value: keyword.name, label: keyword.name,
      }));
      keywordsByCategory.industry = data?.industry?.map((keyword) => ({
         id: `${ keyword.id }`, value: keyword.name, label: keyword.name,
      }));
      return keywordsByCategory;
   },
};

export default modalConfig;
